<template>
   <img :src="imageUrl || noImageUrl" :alt="altText" @error="onError"  />
</template>

<script>
export default {
  name: 'app-image',
  props: {
    imageUrl: {
      default: null
    },
    altText: {
      type: String,
      default: 'iamge'
    }
  },
  data () {
    return {
      noImageUrl: '/static/images/noimage.jpg'
    }
  },
  methods: {
    onError (e) {
      e.target.scr = this.noImageUrl
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// image.vue?5eab203f